module.exports = __webpack_public_path__ + "4d6580692044fb346944639771e448d6.pdf";